import Cookies from 'js-cookie';
import { loadJs } from '../utils';

export default class CookieBar {
	static init() {
		document.addEventListener('bless', () => {
			const cookiebars = document.querySelectorAll('#cookie-notice');

			cookiebars.forEach(cookiebar => {
				new CookieBar(cookiebar);
			});
		});
	}

	constructor(cookiebar) {

		this.cookie = Cookies.get('cookiemessage');
		this.cookiebar = cookiebar;

		if(!this.cookiebar) {
			return;
		}

		this.acceptButton = this.cookiebar.querySelector('.c-cookie-notice__accept');
		this.declineButton = this.cookiebar.querySelector('.c-cookie-notice__decline');

		if(!this.cookie) {
			this.acceptButton.addEventListener('click', this.accept.bind(this));
			this.declineButton.addEventListener('click', this.decline.bind(this));
			this.show();
		} else {
			this.cookiebar.remove();
			if (this.cookie !== 'declined') {
				this.loadGaAndTrack();
			}
		}
	}

	show() {
		this.cookiebar.classList.add('active');
		this.cookiebar.focus();
	}

	hide() {
		this.cookiebar.classList.remove('active');
	}

	accept() {
		Cookies.set('cookiemessage', 'accepted', { expires: 365 });
		this.hide();
		this.loadGaAndTrack();
	}

	decline() {
		Cookies.set('cookiemessage', 'declined');
		this.hide();
	}

	loadGaAndTrack() {
        this.loadGa()
            .then(() => {
                this.track();
            })
            .catch(message => {
                console.warn(message);
            });
    }

	loadGa() {
		return new Promise((resolve, reject) => {
			if (window.WPURLS.env !== 'production') {
				reject('Niet op productie dus GA wordt niet ingeladen.');
				return;
			}
			loadJs('https://www.google-analytics.com/analytics.js').then(() => {
				ga('create', 'UA-33755369-1', 'auto');

                this.gaLoaded = true;

                resolve();
			});
		});
	}
	track() {
		if (window.WPURLS.env !== 'production') {
            return;
        }

        ga('set', 'page', window.location.pathname);
        ga('send', 'pageview');
	}
}
